import {useState,useEffect} from "react";
import {useGetAccountQuery,useChangeDisplayNameMutation} from './redux/databaseView';
import {useChangePasswordMutation,} from './redux/authApi';
import {
    Alert,
    Box,
    Button,
    Paper,
    Stack,
    TextField,
	CircularProgress,
    Typography
    } from "@mui/material";


const md5=require('md5');
	
export default function Account()
    {
	const [displayName,setDisplayName]=useState("");
    const [currentPassword,setCurrentPassword]=useState("");
    const [newPassword,setNewPassword]=useState("");
    const [confirmPassword,setConfirmPassword]=useState("");
	const [changePassword,{isLoading:passwordLoading}]=useChangePasswordMutation();
	const [changeDisplayName,{isLoading:nameLoading}]=useChangeDisplayNameMutation();
	const {data:account}=useGetAccountQuery();
	const [message,setMessage]=useState("");
	const [error,setError]=useState("");
	const email=account?.data?.email??"";
	useEffect(()=>
    {
    if (account?.data)
		setDisplayName(account.data.displayName??"");
    },[account]);
	
	async function updateDisplayName()
		{
		setError("");
		setMessage("");

		const result=await changeDisplayName({
			displayName
			}).unwrap();
		if (!result.failure)
			setMessage("Display name updated.");
		else
			setError(result.failure)
		}
		
async function updatePassword()
    {
    setError("");
    setMessage("");

    if (newPassword!==confirmPassword)
        {
        setError("New passwords do not match.");
        return;
        }

    const result=await changePassword({
            email,
			currentPassword:md5(currentPassword),
			password:md5(newPassword)
            }).unwrap();
	if (!result.failure)
		{
		setCurrentPassword("");
		setNewPassword("");
		setConfirmPassword("");
		setMessage("Password changed.");
		}
	else
		setError(result.failure)
    }
	
    return (
        <Box
            sx={{
                width:"100%",
                overflowY:"auto",
                p:3
                }}
        >
			{error&&
				<Alert
					severity="error"
					sx={{mb:2}}
				>
					{error}
				</Alert>
			}

			{message&&
				<Alert
					severity="success"
					sx={{mb:2}}
				>
					{message}
				</Alert>
			}
            <Box
                sx={{
                    maxWidth:650,
                    mx:"auto"
                    }}
            >

				<Paper
					variant="outlined"
					sx={{p:3,mb:3}}
				>
					<Typography variant="h6" sx={{mb:2}}>
						Name
					</Typography>

					<Stack
						direction={{xs:"column",sm:"row"}}
						spacing={2}
						alignItems={{sm:"center"}}
					>
						<TextField
							label="Display Name"
							value={displayName}
							disabled={nameLoading}
							onChange={(event)=>setDisplayName(event.target.value)}
							fullWidth
							size="small"
						/>

						<Button
							variant="contained"
							onClick={updateDisplayName}
							sx={{whiteSpace:"nowrap"}}
							disabled={nameLoading}
							startIcon={
								nameLoading
									?<CircularProgress size={16} color="inherit"/>
									:null
								}
						>
							Save
						</Button>
					</Stack>
				</Paper>

                <Paper
                    variant="outlined"
                    sx={{p:3}}
                >
                    <Typography variant="h6" sx={{mb:2}}>
                        Password
                    </Typography>

                    <Stack spacing={2}>
                        <TextField
                            label="Current Password"
                            type="password"
                            value={currentPassword}
							disabled={passwordLoading}
                            onChange={(event)=>setCurrentPassword(event.target.value)}
                            fullWidth
                            size="small"
                        />

                        <TextField
                            label="New Password"
                            type="password"
							disabled={passwordLoading}
                            value={newPassword}
                            onChange={(event)=>setNewPassword(event.target.value)}
                            fullWidth
                            size="small"
                        />

                        <TextField
                            label="Confirm New Password"
                            type="password"
							disabled={passwordLoading}
                            value={confirmPassword}
                            onChange={(event)=>setConfirmPassword(event.target.value)}
                            fullWidth
                            size="small"
                        />

                        <Box>
                            <Button
                                variant="contained"
                                onClick={updatePassword}
								disabled={passwordLoading}
								startIcon={
									passwordLoading
										?<CircularProgress size={16} color="inherit"/>
										:null
									}
                            >
                                Change Password
                            </Button>
                        </Box>
                    </Stack>
                </Paper>
            </Box>
        </Box>
        );
    }